import {
  LabeledButton,
  LabeledButtonContent,
  LabeledButtonLabel,
} from "@babackapp/customer-ui/components/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@babackapp/customer-ui/components/dropdown-menu";
import { Label } from "@babackapp/customer-ui/components/label";
import {
  Option,
  OptionAction,
  OptionContent,
  OptionDescription,
  OptionIcon,
  OptionTitle,
} from "@babackapp/customer-ui/components/option";
import { RadioGroupItem } from "@babackapp/customer-ui/components/radio-group";
import { ChevronsUpDown, StoreIcon } from "lucide-react";
import { Controller, type Control } from "react-hook-form";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";

type Store = {
  id?: string | null;
  name?: string | null;
  address?: { address1?: string | null; city?: string | null } | null;
};

type FormValues = {
  returnMode: string;
  pickupDate?: string;
  storeId?: string;
};

type Props = {
  control: Control<FormValues>;
  selected: boolean;
  selectableStores: Store[];
};

export function StoreOption({ control, selected, selectableStores }: Props) {
  const t = useCustomText();
  return (
    <Label htmlFor="store">
      <Option>
        <OptionIcon>
          <StoreIcon />
        </OptionIcon>
        <OptionTitle>{t("returnMode.store.title")}</OptionTitle>
        <OptionDescription>
          {t("returnMode.store.description")}
        </OptionDescription>
        <OptionAction>
          <RadioGroupItem value="store" id="store" />
        </OptionAction>
        <OptionContent>
          {selected && (
            <Controller
              control={control}
              name="storeId"
              render={({ field }) => (
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <LabeledButton variant="outline">
                      <LabeledButtonLabel>{t("returnMode.store.storeLabel")}</LabeledButtonLabel>
                      <LabeledButtonContent>
                        {field.value
                          ? selectableStores.find((s) => s.id === field.value)?.name ||
                            t("returnMode.store.storeSelected")
                          : t("returnMode.store.noStoreSelected")}
                      </LabeledButtonContent>
                      <ChevronsUpDown />
                    </LabeledButton>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent className="w-full">
                    <DropdownMenuRadioGroup
                      value={field.value}
                      onValueChange={field.onChange}
                    >
                      {selectableStores.map((store) => (
                        <DropdownMenuRadioItem key={store.id} value={store.id || ""}>
                          <div>
                            <div className="font-medium">{store.name}</div>
                            <div className="text-xs text-muted-foreground">
                              {store.address?.address1}, {store.address?.city}
                            </div>
                          </div>
                        </DropdownMenuRadioItem>
                      ))}
                    </DropdownMenuRadioGroup>
                  </DropdownMenuContent>
                </DropdownMenu>
              )}
            />
          )}
        </OptionContent>
      </Option>
    </Label>
  );
}
